export const DebugInfo = (key, value) => {
	window.dispatchEvent(new CustomEvent('addDebugInfo', { detail: { key: key, value: value } }));
};
